/**
 * @desc 校验调拨数量
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.wms.CheckDemandQtyRequestDto>, options?: any) {
  return updateResponse(
    http(URL + `/allocationPlan/checkDemandQty`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
